import React from "react"
import NumberInput from "./NumberInput"

/**
 * Input de monto con formato es-AR y etiqueta de moneda como texto.
 *
 * value    : number | ""  (sin formato)
 * onChange  : (value: number | "") => void
 * currency  : "ARS" | "USD" | ""  (default "ARS")
 * currencyPosition : "prefix" | "suffix"  (default "suffix")
 */
const AmountInput = ({
  value,
  onChange,
  nroDecimales = 2,
  minDecimals,
  currency = "ARS",
  currencyPosition = "suffix",
  currencySeparator = " ",
  className,
  ...props
}) => {
  const hasCurrency = currency !== ""
  const isPrefix = currencyPosition === "prefix"

  const inputStyle = hasCurrency
    ? isPrefix
      ? { paddingLeft: "48px" }
      : { paddingRight: "48px" }
    : undefined

  const labelStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "#6c757d",
    fontSize: "0.875rem",
    ...(isPrefix ? { left: "10px" } : { right: "10px" }),
  }

  return (
    <div style={{ position: "relative" }}>
      {hasCurrency && isPrefix && (
        <span style={labelStyle} aria-hidden="true">
          {currency}
          {currencySeparator}
        </span>
      )}

      <NumberInput
        value={value}
        onChange={onChange}
        nroDecimales={nroDecimales}
        minDecimals={minDecimals}
        style={inputStyle}
        className={className}
        {...props}
      />

      {hasCurrency && !isPrefix && (
        <span style={labelStyle} aria-hidden="true">
          {currencySeparator}
          {currency}
        </span>
      )}
    </div>
  )
}

export default AmountInput
